<template>
  <div
    class="form-input"
    :class="{
      'form-input--valid': valid,
      'form-input--invalid': invalid,
      'form-input--focused': focused,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  valid: boolean;
  invalid: boolean;
  focused: boolean;
}>();
</script>

<style lang="scss">
.form-input {
  position: relative;
  display: block;

  &.form-input--valid {
    .select,
    textarea,
    input {
      border-color: palette(orientation, green);
    }

    .radio-button,
    .checkbox {
      &:before {
        border-color: palette(orientation, green);
      }
    }
  }

  &.form-input--invalid {
    .select,
    textarea,
    input {
      border-color: palette(orientation, red);
    }

    .radio-button,
    .checkbox {
      &:before {
        border-color: palette(orientation, red);
      }
    }
  }

  &.form-input--focused {
    .select,
    textarea,
    input {
      border-color: palette(grey, dark);
      border-width: map-get($border-width, 's');
    }

    .radio-button,
    .checkbox {
      &:before {
        border-color: palette(grey, dark);
        border-width: map-get($border-width, 's');
      }
    }
  }
}
</style>
